__turbopack_context__.v({
  "emailLink": "VacancyComponent-module-scss-module__mDV6Wq__emailLink",
  "vacancyPage": "VacancyComponent-module-scss-module__mDV6Wq__vacancyPage",
  "vacancyPageBlock": "VacancyComponent-module-scss-module__mDV6Wq__vacancyPageBlock",
  "vacancyPageBlockDescription": "VacancyComponent-module-scss-module__mDV6Wq__vacancyPageBlockDescription",
  "vacancyPageBlockTitle": "VacancyComponent-module-scss-module__mDV6Wq__vacancyPageBlockTitle",
  "vacancyPageHead": "VacancyComponent-module-scss-module__mDV6Wq__vacancyPageHead",
});
